// Expose action cable
import * as ActionCable from '@rails/actioncable'

const channels = require.context('.', true, /_channel\.js$/)
channels.keys().forEach(channels)
window.App || (window.App = {})
window.App.cable = ActionCable.createConsumer()
